import React from 'react';
import Grid2 from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Card, CardActions, CardContent} from "@mui/material";
import domotiqueFemme from '../../images/domotiqueFemmee.jpg';
import ThermostatAutoIcon from '@mui/icons-material/ThermostatAuto';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import RollerShadesIcon from '@mui/icons-material/RollerShades';
import BalconyIcon from '@mui/icons-material/Balcony';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import ContactUs from "../ContactUs";
import Button from "@mui/material/Button";
import Partenaires from "../Partenaires";
import AnimatedBackgroundBox from "../AnimationBackgroundBox";

const Domotique = () => {
    return (
        <React.Fragment>
            <AnimatedBackgroundBox backgroundImage={domotiqueFemme} position={'center'} size={'200%'}>

                <Typography variant="h2" sx={{ fontWeight: 'bold', color: '#ebefef', fontFamily: 'unset',
                    textShadow: `
                            0px 0px 8px rgba(0, 0, 0, 0.3),   
                            0px 0px 16px rgba(0, 0, 0, 0.3),  
                            0px 0px 24px rgba(0, 0, 0, 0.3)   
                        `,
                    fontSize: {
                        xs: '2.5rem', // Taille plus petite sur les téléphones
                        sm: '2.5rem', // Taille moyenne sur les tablettes
                        md: '5rem', // Taille normale sur les grands écrans
                    },
                }}>
                    Domotique
                </Typography>

                    {/*            <Typography variant="body2" sx={{ color: 'text.secondary' }}>*/}
                    {/*                Automatisez votre maison avec des solutions connectées.*/}
                    {/*                Confort, sécurité et économie d'énergie à portée de main.*/}
                    {/*            </Typography>*/}


                {/*<Box sx={{*/}
                {/*    justifyContent: 'right',*/}
                {/*    alignItems: 'right',*/}

                {/*}}>*/}
                {/*    <img*/}
                {/*        src={maisonConnecte}*/}
                {/*        alt="Maison Domotique"*/}
                {/*        style={{*/}
                {/*            maxWidth: '100%',*/}
                {/*            height: '80%',*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</Box>*/}
            </AnimatedBackgroundBox>

            <Box sx={{
                padding: { xs: '20px ', md: '70px 0' },
                //backgroundColor: 'rgba(233,240,246,0.98)'
                backgroundColor: '#f0f4fa'
            }}>
                <Box sx={{ maxWidth: 'lg', margin: 'auto', textAlign: 'center' }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontFamily: 'unset',
                            color: '#2c2d2e',
                            paddingBottom: '50px',
                            textAlign: 'center', // Centrage du texte
                            //fontStyle: 'italic'
                            fontSize: { xs: '1.5rem', md: '2rem' }

                        }}
                    >
                        Optimisez votre confort et votre sécurité avec nos solutions de domotique sur mesure, adaptées à vos besoins.
                        {/*Que ce soit pour l'installation, la rénovation ou la maintenance de vos systèmes électriques, nous garantissons sécurité, performance et conformité, tout en optimisant votre consommation énergétique.*/}
                    </Typography>

                    <Grid2 container spacing={4} justifyContent="center"> {/* Centrage des cartes */}
                        {/** Tableau de données pour les cartes */}
                        {[
                            {
                                icon: <ThermostatAutoIcon sx={{ fontSize: 75, color: '#e6701c', mb: 2 }} />,
                                title: "THERMOSTAT INTELLIGENT",
                                description: "Contrôlez la température de votre maison à distance avec un thermostat intelligent, pour un confort optimal tout en réduisant vos coûts énergétiques.",
                            },
                            {
                                icon: <TipsAndUpdatesIcon sx={{ fontSize: 75, color: '#ecf310', mb: 2 }} />,
                                title: "AUTOMATISATION DE L'ÉCLAIRAGE",
                                description: "Contrôlez l'éclairage de votre maison depuis votre smartphone, programmez des ambiances lumineuses selon vos besoins et optimisez votre consommation d'énergie grâce à des capteurs intelligents.",
                            },
                            {
                                icon: <RollerShadesIcon sx={{ fontSize: 75, color: '#3c89ec', mb: 2 }} />,
                                title: "VOLETS ROULANTS AUTOMATIQUES",
                                description: "Automatisez l'ouverture et la fermeture de vos volets roulants à des heures programmées ou en fonction de la lumière naturelle, pour plus de confort et de sécurité.",
                            },
                            {
                                icon: <BalconyIcon sx={{ fontSize: 75, color: '#3c89ec', mb: 2 }} />,
                                title: "PORTAIL ET GARAGE CONNECTÉS",
                                description: "Contrôlez à distance l'ouverture et la fermeture de votre portail ou de votre porte de garage, ou programmez leur fonctionnement automatique selon vos horaires.",
                            },
                        ].map((card, index) => (
                            <Grid2 xs={12} sm={6} md={6} key={index}>
                                <Card
                                    sx={{
                                        minWidth: 300,
                                        minHeight: 300,
                                        maxHeight: 350,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 8,
                                        //boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.2)' // Ombre plus accentuée
                                        boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '

                                    }}
                                >
                                    <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                        {card.icon}
                                        <Typography variant="h5" sx={{ mb: 1.5, fontFamily: 'unset' }}>
                                            {card.title}
                                        </Typography>
                                        <Typography variant="body1" sx={{ fontFamily: 'unset' }}>
                                            {card.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid2>
                        ))}
                        <Grid2 xs={12} sm={12} md={12}>
                            <Card
                                sx={{
                                    minWidth: 300,
                                    minHeight: 300,
                                    maxHeight: 350,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    //backgroundColor: '#e9eff3',
                                    borderRadius: 8,
                                    //boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.2)'  // Ombre plus accentuée
                                    boxShadow: '0px 5px 5px rgb(170, 187, 250, 0.5), 0px 5px 10px rgb(170, 187, 250, 0.4) '

                                }}
                            >
                                <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    <EuroSymbolIcon sx={{ fontSize: 75, color: '#3c89ec', mb: 2 }} />
                                    <Typography variant="h5" sx={{ mb: 1.5, fontFamily: 'unset' }}>
                                        SUBVENTIONS & AIDES
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontFamily: 'unset' }}>
                                        Profitez des aides de l’État pour vos projets de rénovation énergétique et
                                        réduisez vos coûts tout en améliorant l'efficacité de votre habitation.
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button href={"https://www.service-public.fr/particuliers/actualites/A16968"}
                                            size="small"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                    >
                                        Aide thermostat connecté
                                    </Button>
                                    <Button href={"https://www.economie.gouv.fr/particuliers/aides-renovation-energetique"}
                                            size="small"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                    >
                                        Tous les types d’aides
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid2>
                    </Grid2>

                </Box>
            </Box>

            <Box>
                <Partenaires></Partenaires>
            </Box>
            <Box>
                <ContactUs></ContactUs>
            </Box>
        </React.Fragment>
    );
};

export default Domotique;